module.exports = __webpack_public_path__ + "img/pip.dc14e2ba.svg";